import { render, staticRenderFns } from "./QuickRepliesSettings.vue?vue&type=template&id=a11590e6&scoped=true&"
import script from "./QuickRepliesSettings.vue?vue&type=script&lang=js&"
export * from "./QuickRepliesSettings.vue?vue&type=script&lang=js&"
import style0 from "./QuickRepliesSettings.vue?vue&type=style&index=0&id=a11590e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11590e6",
  null
  
)

export default component.exports